import { Sparkles } from "lucide-react";

import { cn } from "@/lib/utils";

export const AI_WATERMARK_TEXT = "Nội dung do AI tạo · chỉ mang tính tham khảo";
export const NO_REFUND_TEXT = "Không hoàn tiền khi đã có kết quả";

/**
 * Nhãn đánh dấu nội dung do AI sinh ra (luận giải, đàm đạo...).
 * Gắn MỘT lần ở cuối mỗi câu trả lời / bài luận giải — không gắn trong renderer markdown
 * dùng chung vì renderer đó còn hiển thị cả nội dung không phải AI (hộp thư, thông báo...).
 * Dùng `div` thay vì `p` để không bị các rule `.talisman p { color: ... !important }` đè màu.
 *
 * `showNoRefund`: tắt ở nơi người xem không trả tiền (trang share công khai, bot hỗ trợ).
 */
export function AiWatermark({
  className,
  showNoRefund = true,
}: {
  className?: string;
  showNoRefund?: boolean;
}) {
  return (
    <div
      role="note"
      className={cn(
        "ai-watermark mt-3 flex items-start gap-1.5 text-[11px] leading-4 text-muted-foreground",
        className,
      )}
    >
      <Sparkles className="mt-0.5 size-3 shrink-0 text-primary/80" aria-hidden />
      <span>
        {AI_WATERMARK_TEXT}
        {showNoRefund ? ` · ${NO_REFUND_TEXT}` : null}
      </span>
    </div>
  );
}
